import React, { FC } from 'react'

import { graphql, useFragment } from 'react-relay'

import { Metadata } from '../Metadata'

import { GuildMetadata_guild$key } from './__generated__/GuildMetadata_guild.graphql'

export const GuildMetadata: FC<{
  guild: GuildMetadata_guild$key
  title?: string
  description?: string
}> = ({ guild, title, description }) => {
  const data = useFragment(
    graphql`
      fragment GuildMetadata_guild on Guild {
        slugId
        name
        description
        backgroundPhoto {
          coverUrl: transformUrl(
            transform: { w: 1200, h: 600, dpr: 1, fit: "cover" }
          )
        }
        defaultCoverUrl: defaultBackgroundUrl(
          transform: { w: 1200, h: 600, dpr: 1, fit: "cover" }
        )
      }
    `,
    guild
  )

  const photoUrl =
    data.backgroundPhoto?.coverUrl || data.defaultCoverUrl

  return (
    <Metadata
      title={title || data.name}
      description={description || data.description}
      imageTransformParams='NONE'
      photoUrl={photoUrl}
    />
  )
}
